import { useSyncExternalStore } from 'react';

import type { MiniAppActionState, MiniAppContext } from '../../types';

import {
  getTasksPanelSnapshot,
  subscribeTasksPanel,
} from './tasks-panel-store';

/**
 * Drives the Tasks action button from the panel-store snapshot (the panel-state
 * hook is the poller — this hook fetches nothing):
 *
 *  - marker `generating` → spinner (extraction in flight);
 *  - otherwise → count pill, explicit 0 included — even with an absent or
 *    unreadable marker (old visit, degraded Medplum session). Hiding would
 *    strand the rail's Add task / Regenerate behind an invisible failure.
 */
export function useTasksActionState(ctx: MiniAppContext): MiniAppActionState {
  const snapshot = useSyncExternalStore(
    subscribeTasksPanel,
    getTasksPanelSnapshot,
  );
  // No published state for THIS session yet (panel not mounted / first fetch
  // still in flight / snapshot is a previous appointment's) → keep hidden.
  if (!ctx.appointmentId || snapshot.appointmentId !== ctx.appointmentId) {
    return { action: { hidden: true } };
  }
  if (snapshot.extraction === 'generating') {
    return { action: { loading: true } };
  }
  const total =
    (snapshot.counts?.pending ?? 0) + (snapshot.counts?.accepted ?? 0);
  return { action: { badge: total } };
}
